<template lang="pug">
  div.buttons
    //- button.row-edit(@click="$root.$emit('editItem', $parent.value)")
    //- button.row-edit(@click="$root.$emit('setModal', $parent.$parent.value)")
    button.row-edit(
      v-if="showEditButton"
      @click="$root.$emit('setModal', currentItem)"
    )
    //- button.row-delete(v-if="$parent.value.deletable" @click="$root.$emit('deleteItem', $parent.value)")
    button.row-delete(
      v-if="showDeleteButton"
      @click="$root.$emit('deleteItem', currentItem)"
    )

</template>

<script>
  export default {
    data() {
      return {
        // showEditButton: true,
        // showDeleteButton: true
      };
    },
    props: ['currentItem'],
    computed: {
      showDeleteButton() {
        return (this.$route.name !== 'Банк данных технологий' && this.$route.name !== 'Административно-территориальное устройство');
      },

      showAddButton() {
        return (this.$route.name !== 'Банк данных технологий');
      },

      showEditButton() {
        return (this.$route.name !== 'Банк данных технологий');
      }
    }
  };
</script>

<style lang="scss">
.buttons{
  display: flex;
  justify-content: flex-end;
  button{
    margin: 0 6px;
    height: 34px;
    width: 34px;
  }
}

.row {
  &-edit {
    background: url('~img/icons/edit-row.svg') no-repeat center center;
    &:hover {
      background: url('~img/icons/edit-row.svg') no-repeat center center #ddd;
    }
  }
  &-add {
    background: url('~img/icons/add-row.svg') no-repeat center center;
    &:hover {
      background: url('~img/icons/add-row.svg') no-repeat center center #ddd;
    }
  }
  &-delete {
    background: url('~img/icons/delete-row.svg') no-repeat center center;
    &:hover {
      background: url('~img/icons/delete-row.svg') no-repeat center center #ddd;
    }
  }
}
</style>
